import { render, staticRenderFns } from "./StatsUnit.vue?vue&type=template&id=42d2ee3b&scoped=true"
import script from "./StatsUnit.vue?vue&type=script&lang=js"
export * from "./StatsUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d2ee3b",
  null
  
)

export default component.exports